<template>
  <div v-if="amReady" class="p-3">
    <el-row class="mb-3">
      <div class="m-0 p-0 mb-4" v-if="formHeader">
        <h6>{{ this.getFormTitle }}</h6>
      </div>
      <div class="mb-2" v-else></div>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            field_mark="required"
            label="name"
            name="name"
            placeholder="Vopatix"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :label_span="24"
            :field_span="16"
            :options="divisionsList"
            :defaultValue="defaultDivision"
            :translateLabel="false"
            :translateLabels="false"
            field_mark="required"
            label="Division"
            name="division_id"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            field_mark="required"
            :translateLabel="false"
            label="prefix"
            name="prefix"
            placeholder="1118"
            rules="required"></dg-text-field>
      </el-col>
    </el-row>

    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Rates Email"
            name="rates_email"
            placeholder="rates@Vopatix.com"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Account Manager Email"
            name="account_manager_email"
            placeholder="manager@Vopatix.com"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Support Email"
            name="support_email"
            placeholder="support@Vopatix.com"
            rules=""></dg-text-field>
      </el-col>
    </el-row>

    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="CDR Account Link"
            name="cdr_account_link"
            placeholder="https://vos-server.com/login"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="CDR Account Username"
            name="cdr_account_username"
            placeholder="Vopatix"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="CDR Account Password"
            name="cdr_account_password"
            placeholder="secret"
            rules=""></dg-text-field>
      </el-col>
    </el-row>

    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="website"
            name="website"
            placeholder="https://Vopatix.com"
            rules=""></dg-text-field>
      </el-col>


      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Skype Account"
            name="skype_account"
            placeholder="skype_account"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="linked-In Account"
            name="linked_in_account"
            placeholder="linked-in"
            rules=""></dg-text-field>
      </el-col>
    </el-row>

    <el-row class="mb-3">

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="phone 1"
            name="phone_number_1"
            placeholder="+112 4672 2123 344"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="phone 2"
            name="phone_number_2"
            placeholder="+112 4672 2123 344"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Address"
            name="address"
            placeholder="USA, Newyork, wall St. 2042T"
            rules=""></dg-text-field>
      </el-col>
    </el-row>

    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Paypal Account"
            name="paypal_account"
            placeholder="paypal@Vopatix.com"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="Wire Transfer Account"
            name="wire_transfer_account"
            placeholder=""
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-radio-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :options="radioOptions"
            :translateLabel="false"
            defaultValue="B"
            :translateLabels="false"
            field_mark="required"
            label="Portal access error"
            name="error_in_cdr_info"
            rules="required"></dg-radio-field>
      </el-col>
    </el-row>


    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
        <dg-text-field
            :control="control"
            :field_span="22"
            :label_span="22"
            :translateLabel="false"
            field_mark="optional"
            label="info"
            name="info"
            placeholder=""
            rules=""
            type="textarea"></dg-text-field>
      </el-col>


      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                          v-show="!this.validData"></dg-label-field>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="removeAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                     type="warning" v-if="editable && editMode"></dg-button>
          <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                     v-if="!editable && editMode"></dg-button>
          <dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
  props: {
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  beforeMount() {
    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
      this.amReady = true
      $vue.nextTick(() => {
        if (this.dataToBind) {
          this.bindController()
          this.defaultDivision = this.dataToBind.division_id
          this.fields['division_id'].field.field_value = this.defaultDivision
          this.fields['division_id'].field.updateValue()
        }
      })
    })
  },
  data() {
    return {
      radioOptions: [
        {
          label: 'Yes',
          value: 'A',
          link_label: ''
        },
        {
          label: 'No',
          value: 'B',
          link_label: ''
        }
      ],
      control: this,
      amReady: false,
      requestOn: false,
      divisionsList: [],
      defaultDivision: null,
      editable: !this.editMode,
      module: {
        ...module
      }
    }
  },
  computed: {
    ...$mapState('voip-vendor-state', ['openedEntity']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  methods: {
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-vendor-state', ['addEntity']),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'create';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        })

      })
    }
  }
}
</script>
